import { useState } from 'react'
import { mutations } from '../../resources'
import actions from '../../store/actions'
import { generateError } from '../../helpers/errors'
import { useDispatch } from '../redux'
import { User } from '../../resources/auth/types'

export const useDissociateFacebook = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const dissociateFacebook = (): Promise<User> => {
        setInProgress(true)
        return mutations
            .dissociateFacebook()
            .then((response) => {
                dispatch(actions.setUser(response))
                setInProgress(false)
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        dissociateFacebook,
        inProgress,
    }
}
